import { render, staticRenderFns } from "./DashBoardStatusCount.vue?vue&type=template&id=5c2847ae"
import script from "./DashBoardStatusCount.vue?vue&type=script&lang=js"
export * from "./DashBoardStatusCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports